import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import Sidebar from '../Sidebar/Sidebar';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <div>
      <Sidebar />
      <Container maxWidth="sm" style={{ textAlign: 'center', marginTop: '50px' }}>
        <Typography variant="h4" gutterBottom>
          Unauthorized Access
        </Typography>
        <Typography variant="body1" gutterBottom>
          You do not have permission to view this page.
        </Typography>
        <Button variant="contained" color="primary" onClick={handleGoBack}>
          Go Back to Home
        </Button>
      </Container>
    </div>
  );
};

export default Unauthorized;
